import { render, staticRenderFns } from "./schiessleiterToday.vue?vue&type=template&id=2bf6daca"
import script from "./schiessleiterToday.vue?vue&type=script&lang=js"
export * from "./schiessleiterToday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports